import React, { useContext, useEffect, useState, useRef } from 'react';
import { Col, Row, Form, Button, InputGroup } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import { schema } from '../../schema';
import { Formik, getIn, FormikProps } from 'formik';
import modelContext from '../../modelContext';
import { EnvForm } from './env_types';

export default function FormEnv(props: any) {
	const model = useContext(modelContext);

	const [submitSuccess, setSubmitSuccess] = useState(false);
	const [touchedSubmit, setTouchedSubmit] = useState(false);
	useEffect(() => { }, [submitSuccess])
	useEffect(() => { }, [touchedSubmit])
	// formik reference
	const formRef = useRef<FormikProps<EnvForm>>(null);
	const [initialValues, setInitialValues] = useState(props.initialValues);

	const [initialRender, setInitialRender] = useState(true);
	const handleFieldOverwrite = () => {
		if (formRef?.current) {
			formRef?.current.setFieldValue(`cell4d:X_DIM`, model.modelJson["cell4d:environmentVariables"]["cell4d:X_DIM"]);
			formRef?.current.setFieldValue(`cell4d:Y_DIM`, model.modelJson["cell4d:environmentVariables"]["cell4d:Y_DIM"]);
			formRef?.current.setFieldValue(`cell4d:Z_DIM`, model.modelJson["cell4d:environmentVariables"]["cell4d:Z_DIM"]);
			formRef?.current.setFieldValue(`cell4d:GEOMETRY`, model.modelJson["cell4d:environmentVariables"]["cell4d:GEOMETRY"]);
			formRef?.current.setFieldValue(`cell4d:TIMESCALE`, model.modelJson["cell4d:environmentVariables"]["cell4d:TIMESCALE"]);
			formRef?.current.setFieldValue(`cell4d:SPACESCALE`, model.modelJson["cell4d:environmentVariables"]["cell4d:SPACESCALE"]);
			formRef?.current.setFieldValue(`cell4d:INACCESSIBLE_SPACE_PERCENT`, model.modelJson["cell4d:environmentVariables"]["cell4d:INACCESSIBLE_SPACE_PERCENT"]);
			formRef?.current.setFieldValue(`cell4d:MAX_CYCLES`, model.modelJson["cell4d:environmentVariables"]["cell4d:MAX_CYCLES"]);
			setTimeout(() => {
				formRef?.current?.validateForm();
			}, 100);
		}
	}
	useEffect(() => {
		if (!initialRender) {
			setInitialValues(props.initialValues);
			handleFieldOverwrite();
		}
		setInitialRender(false);
	}, [props.initialValues])

	const envErrorsMap = (error_string: string, field: string = ""): string => {
		let return_string = "";
		if (error_string === "missing_var") {
			return_string = "This field cannot be empty."
		} else if (error_string === "no_match") {
			return_string = "At least 1 dimension must be 3 or greater for channel geometry."
		} else if (error_string === "invalid_var") {
			if(["cell4d:X_DIM", "cell4d:Y_DIM", "cell4d:Z_DIM"].includes(field)) {
				return_string = "Dimensions must be positive integer values."
			} else if(["cell4d:TIMESCALE", "cell4d:SPACESCALE"].includes(field)) {
				return_string = "The scale value should be less than 1 (e.g. 1e-6)."
			} else if(["cell4d:INACCESSIBLE_SPACE_PERCENT"].includes(field)) {
				return_string = "Percentage should be between 0 and 100."
			} else if(["cell4d:MAX_CYCLES"].includes(field)) {
				return_string = "Max time-cycles must be a positive integer value."
			} else {
				return_string = "This field is invalid."
			}
		}
		return (return_string);
	}

	const handleSubmit = (values: any) => {
		let formObj = {
			"cell4d:X_DIM": {
				"_text": values["cell4d:X_DIM"]._text
			},
			"cell4d:Y_DIM": {
				"_text": values["cell4d:Y_DIM"]._text
			},
			"cell4d:Z_DIM": {
				"_text": values["cell4d:Z_DIM"]._text
			},
			"cell4d:GEOMETRY": {
				"_text": values["cell4d:GEOMETRY"]._text
			},
			"cell4d:TIMESCALE": {
				"_text": parseFloat(values["cell4d:TIMESCALE"]._text)
			},
			"cell4d:SPACESCALE": {
				"_text": parseFloat(values["cell4d:SPACESCALE"]._text)
			},
			"cell4d:INACCESSIBLE_SPACE_PERCENT": {
				"_text": values["cell4d:INACCESSIBLE_SPACE_PERCENT"]._text
			},
			"cell4d:MAX_CYCLES": {
				"_text": values["cell4d:MAX_CYCLES"]._text
			}
		}

		// validateModel input order is comparts, annot, metabs, species
		let modelStatus = model.validateModel();
		modelStatus[0] = true;
		model.setModelStatus(model.validateModel());

		// because handleSubmit was successfully called, new envVar tab is correct for sure, so set it to true.
		model.appendModelJson("cell4d:environmentVariables", formObj);
		setSubmitSuccess(true);
		setTouchedSubmit(false);

	}

	return (
		<div>
			<Formik
				innerRef={formRef}
				validationSchema={schema.envVar}
				onSubmit={handleSubmit}
				enableReinitialize={false}
				initialValues={initialValues}
			>
				{({
					handleSubmit,
					handleChange,
					handleBlur,
					values,
					touched,
					isValid,
					errors,
				}) => (
					<Form onSubmit={handleSubmit} noValidate autoComplete="off">
						<Row className="justify-content-md-center"><Col sm={10}>
							<Form.Row>
								<Form.Group as={Col} md="4" controlId="validationFormik01">
									<Form.Label>X-Dim</Form.Label>
									<InputGroup size="sm">
										<Form.Control
											// type="number"
											name={`cell4d:X_DIM._text`}
											value={values["cell4d:X_DIM"]._text}
											onChange={handleChange}
											onBlur={handleBlur}
											isValid={getIn(touched, 'cell4d:X_DIM._text') && !getIn(errors, 'cell4d:X_DIM._text')}
											isInvalid={getIn(touched, 'cell4d:X_DIM._text') && !!getIn(errors, 'cell4d:X_DIM._text')}
										/>
										<Form.Control.Feedback type="invalid">{envErrorsMap(getIn(errors, 'cell4d:X_DIM._text'), "cell4d:X_DIM")}</Form.Control.Feedback>
									</InputGroup>
								</Form.Group>
								<Form.Group as={Col} md="4" controlId="validationFormik02">
									<Form.Label>Y-Dim</Form.Label>
									<InputGroup size="sm">
										<Form.Control
											// type="number"
											name="cell4d:Y_DIM._text"
											value={values["cell4d:Y_DIM"]._text}
											onChange={handleChange}
											onBlur={handleBlur}
											isValid={getIn(touched, 'cell4d:Y_DIM._text') && !getIn(errors, 'cell4d:Y_DIM._text')}
											isInvalid={getIn(touched, 'cell4d:Y_DIM._text') && !!getIn(errors, 'cell4d:Y_DIM._text')}
										/>
										<Form.Control.Feedback type="invalid">{envErrorsMap(getIn(errors, 'cell4d:Y_DIM._text'), "cell4d:Y_DIM")}</Form.Control.Feedback>
									</InputGroup>
								</Form.Group>
								<Form.Group as={Col} md="4" controlId="validationFormik03">
									<Form.Label>Z-Dim</Form.Label>
									<InputGroup size="sm">
										<Form.Control
											// type="number"
											name="cell4d:Z_DIM._text"
											value={values["cell4d:Z_DIM"]._text}
											onChange={handleChange}
											onBlur={handleBlur}
											isValid={getIn(touched, 'cell4d:Z_DIM._text') && !getIn(errors, 'cell4d:Z_DIM._text')}
											isInvalid={getIn(touched, 'cell4d:Z_DIM._text') && !!getIn(errors, 'cell4d:Z_DIM._text')}
										/>
										<Form.Control.Feedback type="invalid">{envErrorsMap(getIn(errors, 'cell4d:Z_DIM._text'), "cell4d:Z_DIM")}</Form.Control.Feedback>
									</InputGroup>
								</Form.Group>
							</Form.Row>
							<Form.Row>
								<Form.Group as={Col} md="4" controlId="validationFormik04">
									<Form.Label>Space-scale</Form.Label>
									<InputGroup size="sm">
										<Form.Control
											type="text"
											name="cell4d:SPACESCALE._text"
											value={values["cell4d:SPACESCALE"]._text}
											onChange={handleChange}
											onBlur={handleBlur}
											isValid={getIn(touched, 'cell4d:SPACESCALE._text') && !getIn(errors, 'cell4d:SPACESCALE._text')}
											isInvalid={getIn(touched, 'cell4d:SPACESCALE._text') && !!getIn(errors, 'cell4d:SPACESCALE._text')}
										/>
										<InputGroup.Append>
											<InputGroup.Text id="ss_exponents">m</InputGroup.Text>
										</InputGroup.Append>
										<Form.Control.Feedback type="invalid">{envErrorsMap(getIn(errors, 'cell4d:SPACESCALE._text'), "cell4d:SPACESCALE")}</Form.Control.Feedback>
									</InputGroup>
								</Form.Group>

								<Form.Group as={Col} md="4" controlId="validationFormik05">
									<Form.Label>Geometry</Form.Label>
									<InputGroup size="sm">
										<Form.Control as="select" custom
											id="dropdown-basic-button"
											name="cell4d:GEOMETRY._text"
											value={values["cell4d:GEOMETRY"]._text}
											onBlur={handleBlur}
											onChange={handleChange}
											isInvalid={getIn(touched, 'cell4d:GEOMETRY._text') && !!getIn(errors, 'cell4d:GEOMETRY._text')}
										>
											<option value="custom">custom</option>
											<option value="cube">cube</option>
											<option value="sphere">sphere</option>
											<option value="channel">channel</option>
											<option value="layer">layer</option>
										</Form.Control>
										<Form.Control.Feedback type="invalid">{envErrorsMap(getIn(errors, 'cell4d:GEOMETRY._text'))}</Form.Control.Feedback>
									</InputGroup>
								</Form.Group>

								<Form.Group as={Col} md="4" controlId="validationFormik06">
									<Form.Label>Inaccessible space</Form.Label>
									<InputGroup size="sm">
										<Form.Control
											// type="number"
											name="cell4d:INACCESSIBLE_SPACE_PERCENT._text"
											value={values["cell4d:INACCESSIBLE_SPACE_PERCENT"]._text}
											onChange={handleChange}
											onBlur={handleBlur}
											isValid={getIn(touched, 'cell4d:INACCESSIBLE_SPACE_PERCENT._text') && !getIn(errors, 'cell4d:INACCESSIBLE_SPACE_PERCENT._text')}
											isInvalid={getIn(touched, 'cell4d:INACCESSIBLE_SPACE_PERCENT._text') && !!getIn(errors, 'cell4d:INACCESSIBLE_SPACE_PERCENT._text')}
										/>
										<InputGroup.Append>
											<InputGroup.Text id="percent">%</InputGroup.Text>
										</InputGroup.Append>
										<Form.Control.Feedback type="invalid">{envErrorsMap(getIn(errors, 'cell4d:INACCESSIBLE_SPACE_PERCENT._text'), "cell4d:INACCESSIBLE_SPACE_PERCENT")}</Form.Control.Feedback>
									</InputGroup>
								</Form.Group>
							</Form.Row>
							<Form.Row>
								<Form.Group as={Col} md="4" controlId="validationFormik07">
									<Form.Label>Time-scale</Form.Label>
									<InputGroup size="sm">
										<Form.Control
											type="text"
											name="cell4d:TIMESCALE._text"
											value={values["cell4d:TIMESCALE"]._text}
											onChange={handleChange}
											onBlur={handleBlur}
											isValid={getIn(touched, 'cell4d:TIMESCALE._text') && !getIn(errors, 'cell4d:TIMESCALE._text')}
											isInvalid={getIn(touched, 'cell4d:TIMESCALE._text') && !!getIn(errors, 'cell4d:TIMESCALE._text')}
										/>
										<InputGroup.Append>
											<InputGroup.Text id="ts_exponents">s</InputGroup.Text>
										</InputGroup.Append>
										<Form.Control.Feedback type="invalid">{envErrorsMap(getIn(errors, 'cell4d:TIMESCALE._text'), "cell4d:TIMESCALE")}</Form.Control.Feedback>
									</InputGroup>
								</Form.Group>
								<Form.Group as={Col} md="4" controlId="validationFormik08">
									<Form.Label>Max. simulation timesteps</Form.Label>
									<InputGroup size="sm">
										<Form.Control
											type="text"
											name="cell4d:MAX_CYCLES._text"
											value={values["cell4d:MAX_CYCLES"]._text}
											onChange={handleChange}
											onBlur={handleBlur}
											isValid={getIn(touched, 'cell4d:MAX_CYCLES._text') && !getIn(errors, 'cell4d:MAX_CYCLES._text')}
											isInvalid={getIn(touched, 'cell4d:MAX_CYCLES._text') && !!getIn(errors, 'cell4d:MAX_CYCLES._text')}
										/>
										<Form.Control.Feedback type="invalid">{envErrorsMap(getIn(errors, 'cell4d:MAX_CYCLES._text'), "cell4d:MAX_CYCLES")}</Form.Control.Feedback>
									</InputGroup>
								</Form.Group>

							</Form.Row>
						</Col></Row>
						<hr />

						<Button type="submit" onClick={() => setSubmitSuccess(false)}>Save Environmental Variables to model</Button>
						{submitSuccess ? <><br /><br /><div className="alert-success col-lg justify-content-md-center">Environmental Variables saved to model!</div></> : 
											 touchedSubmit ? <><br /><br /><div className="alert-danger col-lg justify-content-md-center">Environmental Variables failed to save.</div></> :
											 null}
						{/* <Row className="text-left">
							<Col>
								<p>Values</p>
								<pre>{JSON.stringify(values, null, 2)}</pre>
							</Col>
							<Col>
								<p>Errors</p>
								<pre>{JSON.stringify(errors, null, 2)}</pre>
							</Col>
						</Row> */}

					</Form>
				)}
			</Formik>
		</div>
	);
}
